import React, { ButtonHTMLAttributes } from "react";
import styles from "./style.module.scss";

interface Props extends ButtonHTMLAttributes<HTMLDivElement> {}

export const ButtonTiny: React.FC<Props> = ({ children, onClick }) => {
  return <div className={styles.ButtonTiny} onClick={onClick} style={{cursor: "pointer"}}>{children}</div>;
};
